import React from "react";
import Button from "react-bootstrap/Button";

function TeamCards(props) {
  return (
    <div className="policy-card team-card">
      <div className="team-card-media">
        <img src={props.imgPath} alt={props.title} className="team-card-img" loading="lazy" />
      </div>

      <div className="team-card-body">
        <h3 className="team-card-name">{props.title}</h3>
        <p className="team-card-role">{props.role}</p>

        <p className="team-card-description">{props.description}</p>

        {props.email ? <p className="team-card-email">{props.email}</p> : null}

        {props.linkedin ? (
          <div className="team-card-actions">
            <Button
              className="custom-yellow-btn team-card-link"
              href={props.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              type="button"
            >
              LinkedIn
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
}
export default TeamCards;
